"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../../Icon/index"));

var _index2 = require("../../../utils/index");

var _constants = require("../../Icon/constants");

require("./FooterSocial.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var socials = [{
  name: _constants.ICON_TYPE_TWITTER,
  link: '/'
}, {
  name: _constants.ICON_TYPE_FACEBOOK,
  link: '/'
}, {
  name: _constants.ICON_TYPE_LINKEDIN,
  link: '/'
}];

function FooterSocial() {
  return /*#__PURE__*/_react.default.createElement("nav", {
    className: "Footer__social"
  }, socials.map(function (_ref, index) {
    var name = _ref.name,
        link = _ref.link;
    return /*#__PURE__*/_react.default.createElement("a", {
      key: (0, _index2.createUniqueKey)(index, name),
      href: link,
      title: name
    }, /*#__PURE__*/_react.default.createElement(_index.default, {
      type: name
    }));
  }));
}

var _default = FooterSocial;
exports.default = _default;